<template>
    <div class="tournament-result-wrap participant-list"  :class="isMobile ? '' : 'window'">
        <div class="tournament-result-type-wrap">
            <div>
                <div class="type" :class="type==='event' ? 'active' : ''" @click="changeType('event')">종목별</div>
                <div class="type" :class="type==='team' ? 'active' : ''" @click="changeType('team')">팀별</div>
                <div class="type" :class="type==='score' ? 'active' : ''" @click="changeType('score')">종합점수</div>
            </div>
        </div>
        <TournamentResultEvent :tournament="tournament" v-if="type==='event'"></TournamentResultEvent>
        <TeamRankPlayerList v-else-if="type==='team'"></TeamRankPlayerList>
        <TournamentStatisticList v-else></TournamentStatisticList>
    </div>

</template>
<script>
    import TournamentResultEvent from './TournamentResultEvent'
    import TeamRankPlayerList from './TeamRankPlayerList'
    import {mapState} from 'vuex'
    import TournamentStatisticList from "./TournamentStatisticList";
    export default{
        components: {TournamentStatisticList, TournamentResultEvent, TeamRankPlayerList},
        computed: {
            ...mapState('tournaments', ['tournament']),
        },
        data(){
            return{
                type: this.$route.query.type || 'event'
            }
        },
        methods: {
            changeType(type){
                const query = this.$route.query
                const _this = this
                this.$router.replace({path: this.$route.path, query: Object.assign({}, query, {type: type})}).catch(() => {
                    _this.$router.go(0)
                })
            }
        }
    }
</script>
